// File: noviopus-ats-client/src/Account/onboardingTracks.ts

export const ACCOUNT_SETUP_PATH = '/account/setup';

const STEP_ORG_DATA = '/organization/create/data';
const STEP_ORG_MEDIA = '/organization/create/media';
const STEP_ORG_WORKPLACE = '/organization/create/workplace';

// --- TRACK ROUTE DEFINITIONS ---

const RECRUITMENT_TRACK = [
  ACCOUNT_SETUP_PATH,
  STEP_ORG_DATA,
  STEP_ORG_MEDIA,
  STEP_ORG_WORKPLACE
];

const SOCIAL_TRACK = [
  ACCOUNT_SETUP_PATH,
  STEP_ORG_DATA,
  STEP_ORG_MEDIA
];

const MANAGEMENT_TRACK = [
  ACCOUNT_SETUP_PATH,
  STEP_ORG_DATA
];

export const ONBOARDING_TRACKS: { [key: string]: string[] } = {
  DEFAULT: RECRUITMENT_TRACK,
  RECRUITMENT: RECRUITMENT_TRACK,
  SOCIAL: SOCIAL_TRACK,
  MANAGEMENT: MANAGEMENT_TRACK
};

// --- STEPPER LABELS ---

export const TRACK_STEP_LABELS: { [key: string]: string[] } = {
  DEFAULT: ['stepper.account', 'stepper.orgData', 'stepper.orgMedia', 'stepper.orgWorkplace'],
  RECRUITMENT: ['stepper.account', 'stepper.orgData', 'stepper.orgMedia', 'stepper.orgWorkplace'],
  SOCIAL: ['stepper.account', 'stepper.orgData', 'stepper.orgMedia'],
  MANAGEMENT: ['stepper.account', 'stepper.orgData']
};

export const getTrackNameForAccount = (account: any): string => {
  if (account && account.onboardingTrack && account.onboardingTrack !== 'DEFAULT') {
    return account.onboardingTrack;
  }
  const s = account?.services || {};
  if (s.recruitment) return 'RECRUITMENT';
  if (s.social || s.ad_campaigns) return 'SOCIAL';
  if (s.organization_management) return 'MANAGEMENT';
  return 'DEFAULT';
};

export const getLabelsForTrack = (trackName: string): string[] => {
    return TRACK_STEP_LABELS[trackName] || TRACK_STEP_LABELS['DEFAULT'];
};

// EXPORTED AS REQUESTED
export const getStepsForTrack = (trackName: string): string[] => {
    return ONBOARDING_TRACKS[trackName] || ONBOARDING_TRACKS['DEFAULT'];
};